import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TERMS } from "../../../config/terminology";
import {
  getQuotaDetailsTable,
  getQuotaForApprovalTable,
  urls,
} from "./quotaUtils";
import { saveAs } from "file-saver";

const initialState = {
  isLoading: false,

  countries: [],
  selectedCountry: "All",
  selectedCountryID: "0",

  QAGlobalCountryID:"",

  navigatedCountryID: "",

  quotaStatusList: [],
  selectedQuotaStatus :"All except Approved/Rejected",
  selectedQuotaStatusKey: "",

  periods: [],
  selectedPeriod: "",
  selectedPeriodKey: "",

  quotaForApproval: [],
  quotaForApprovalTable: null,
  quotaTSelRow: [],
  quotaCustomerBreakdown: null,
  quotaDetailsTable: null,

  popupGraphData: null,
  graphModalOpen: false,

  selectedRows: [],

  rejectSelModalOpen: false,
  rejectSelectedComment: "",

  rejectSingleModalOpen: false,

  appMulWithCommentModal: false,
  appMulWithComment: "",
  selectedQuotaid: null,
  approveSingleWithCommentsModalOpen: false,
  message: "",
  severity: "",
  messageOpen: false,
  files: [],
  filepaths: [],
  searchText: "",
  redirectedFromDashboard: false,
};

export const getUserCountries = createAsyncThunk(
  "quota/getUserCountries",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.userCountries + `userid=${data.userID}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getUserCountries", error);
    }
  }
);

export const getQuotaStatus = createAsyncThunk(
  "quota/getQuotaStatus",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.quotaStatus;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getQuotaStatus", error);
    }
  }
);

export const getPeriods = createAsyncThunk(
  "quota/getPeriods",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.periods;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getPeriods", error);
    }
  }
);

export const getQuotaForApproval = createAsyncThunk(
  "quota/getQuotaForApproval",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.quotaForApproval;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getQuotaForApproval", error);
    }
  }
);

export const getQuotaCustomerBreakdown = createAsyncThunk(
  "quota/getQuotaCustomerBreakdown",
  async (obj, thunkAPI) => {
    try {
      const { quotaId } = obj;
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.quotaCustomerBreakdown + `quotaId=${quotaId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getQuotaCustomerBreakdown", error);
    }
  }
);

//post call
export const approveQuota = createAsyncThunk(
  "quota/approveQuota",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.approve;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/approveQuota", error);
    }
  }
);

export const ApproveQuotaWithComments = createAsyncThunk(
  "quota/ApproveQuotaWithComments",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.approveQuotaWithComments;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/approveQuotaWithComments", error);
    }
  }
);

//post call
export const rejectQuota = createAsyncThunk(
  "quota/rejectQuota",
  async (formData, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.reject;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Disposition": "multipart/form-data",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: formData,
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/rejectQuota", error);
    }
  }
);

export const getPopupGraphData = createAsyncThunk(
  "quota/getPopupGraphData",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const { scenarioID } = obj;
      const url = urls.popupGraphData + `scenarioID=${scenarioID}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/getPopupGraphData", error);
    }
  }
);

//post call
export const lockUnlockQuota = createAsyncThunk(
  "quota/lockUnlockQuota",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.lockUnlockQuota;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/lockUnlockQuota", error);
    }
  }
);

//post call
export const approveMultiple = createAsyncThunk(
  "quota/approveMultiple",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.approveMultiple;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/approveMultiple", error);
    }
  }
);

//post call
export const lockUnlockMultiple = createAsyncThunk(
  "quota/lockUnlockMultiple",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.lockUnlockMultiple;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/lockUnlockMultiple", error);
    }
  }
);

//post call
export const rejectMultiple = createAsyncThunk(
  "quota/rejectMultiple",
  async (obj, { dispatch, getState }) => {
    try {
      const { filepaths } = getState().quota;
      if (
        filepaths !== undefined &&
        filepaths != null &&
        filepaths.length > 0
      ) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].quotaFiles = filepaths;
        }
      }
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.rejectMultiple;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/rejectMultiple", error);
    }
  }
);

//post call
export const approveMultipleWithComment = createAsyncThunk(
  "quota/approveMultipleWithComment",
  async (obj, thunkAPI) => {
    try {
      const data = JSON.parse(localStorage.getItem("data"));
      const token = data.token;
      const url = urls.approveMulWithComment;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          Accept: "application/json",
        },
        body: JSON.stringify(obj),
      });
      const jsonData = response.json();
      return jsonData;
    } catch (error) {
      console.error("quota/approveMultipleWithComment", error);
    }
  }
);
export const DownloadFile = createAsyncThunk(
  "define/downloadfile",
  async (filepath, thunkAPI) => {
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const url = urls.Downloadfile + `fileName=${filepath}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      const res = await response.blob();
      const fileName = filepath;
      saveAs(res, fileName);
      return res;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);
export const Upload = createAsyncThunk(
  "approval/Upload",
  async (obj, { dispatch, getState }) => {
    const { files } = getState().quota;
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;
    const formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      formData.append("files", files[i], files[i].name);
    }
    const url = urls.Upload;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Disposition": "multipart/form-data",
        },
        body: formData,
      });
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("Error: ", error);
    }
  }
);

export const quotaSlice = createSlice({
  name: "quota",
  initialState,
  reducers: {
    setState: {
      prepare(name, value) {
        return {
          payload: { name, value },
        };
      },
      reducer(state, action) {
        const { name, value } = action.payload;
        state[name] = value;
      },
    },
    reset(state, { payload }) {
      if (payload === "refresh") {
        state.isLoading = false;
        if (!state.redirectedFromDashboard) {
          if(state.QAGlobalCountryID===""){
          state.selectedCountry = "All";
          state.selectedCountryID = "0";
          }

        }
        state.selectedQuotaStatus = "All except Approved/Rejected";
        state.selectedQuotaStatusKey = "";
        if(state.periods !== null && state.periods !== undefined && state.periods?.length > 0){
          let idx = state.periods.findIndex(p => p.key == "0");
          if (idx >= 0) state.selectedPeriod = state.periods[idx]?.value;
        }else{
          state.selectedPeriod = "";
        }
        state.selectedPeriodKey = "";

        state.quotaForApproval = [];
        state.quotaForApprovalTable = null;
        state.quotaTSelRow = [];
        state.quotaCustomerBreakdown = null;
        state.quotaDetailsTable = null;

        state.popupGraphData = null;
        state.graphModalOpen = false;

        state.selectedRows = [];
        state.rejectSelectedComment = "";

        state.appMulWithComment = "";
        state.selectedQuotaid = null;
        state.searchText="";
        state.redirectedFromDashboard = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserCountries.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getUserCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
        state.isLoading = false;
      })
      .addCase(getUserCountries.rejected, (state, action) => {
        console.error("quota/getUserCountries", action.error.message);
        state.isLoading = false;
      })

      .addCase(getQuotaStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQuotaStatus.fulfilled, (state, action) => {
        state.quotaStatusList = action.payload;
        state.isLoading = false;
      })
      .addCase(getQuotaStatus.rejected, (state, action) => {
        console.error("quota/getQuotaStatus", action.error.message);
        state.isLoading = false;
      })

      .addCase(getPeriods.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPeriods.fulfilled, (state, action) => {
        state.periods = action.payload;
        let idx = action.payload.findIndex(p => p.key == "0");
        if (idx >= 0) state.selectedPeriod = state.periods[idx].value;
        state.isLoading = false;
      })
      .addCase(getPeriods.rejected, (state, action) => {
        console.error("quota/getPeriods", action.error.message);
        state.isLoading = false;
      })

      .addCase(getQuotaForApproval.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQuotaForApproval.fulfilled, (state, action) => {
        state.quotaForApproval = action.payload;
        if(state.quotaForApproval.length === 0){
          state.messageOpen = true;
          state.message = "No records found.";
          state.severity = "info";
        }
        state.quotaForApprovalTable = getQuotaForApprovalTable(action.payload);
        state.isLoading = false;
      })
      .addCase(getQuotaForApproval.rejected, (state, action) => {
        console.error("quota/getQuotaForApproval", action.error.message);
        state.isLoading = false;
      })

      .addCase(getQuotaCustomerBreakdown.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getQuotaCustomerBreakdown.fulfilled, (state, action) => {
        state.quotaCustomerBreakdown = action.payload;
        state.quotaDetailsTable = getQuotaDetailsTable(
          action.payload.listQuotaCustomers
        );
        state.isLoading = false;
      })
      .addCase(getQuotaCustomerBreakdown.rejected, (state, action) => {
        console.error("quota/getQuotaCustomerBreakdown", action.error.message);
        state.isLoading = false;
      })

      .addCase(approveQuota.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(approveQuota.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === true) {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Approved Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Approval Failed`;
          state.severity = "error";
        }
      })
      .addCase(approveQuota.rejected, (state, action) => {
        console.error("quota/approveQuota", action.error.message);
        state.isLoading = false;
        state.messageOpen = true;
        state.message = `${TERMS.QUOTA} Approval Failed`;
        state.severity = "error";
      })
      .addCase(ApproveQuotaWithComments.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(ApproveQuotaWithComments.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === true) {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Approved Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Approval Failed`;
          state.severity = "error";
        }
      })
      .addCase(ApproveQuotaWithComments.rejected, (state, action) => {
        console.error("quota/approveQuota", action.error.message);
        state.isLoading = false;
        state.messageOpen = true;
        state.message = `${TERMS.QUOTA} Approval Failed`;
        state.severity = "error";
      })

      .addCase(rejectQuota.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(rejectQuota.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === true) {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Rejected Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Rejection Failed`;
          state.severity = "error";
        }
      })
      .addCase(rejectQuota.rejected, (state, action) => {
        console.error("quota/rejectQuota", action.error.message);
        state.isLoading = false;
        state.messageOpen = true;
        state.message = `${TERMS.QUOTA} Rejection Failed`;
        state.severity = "error";
      })

      .addCase(getPopupGraphData.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPopupGraphData.fulfilled, (state, action) => {
        state.popupGraphData = action.payload.approvalDataChartDataBOList;
        state.isLoading = false;
      })
      .addCase(getPopupGraphData.rejected, (state, action) => {
        console.error("quota/getPopupGraphData", action.error.message);
        state.isLoading = false;
      })

      .addCase(lockUnlockQuota.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(lockUnlockQuota.fulfilled, (state, action) => {
        state.isLoading = false;
        if (typeof action.payload == "string") {
          state.messageOpen = true;
          state.message = action.payload;
          state.severity = "error";
        } else if (action.payload.isSubmitLocked) {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Locked Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `${TERMS.QUOTA} Unlocked Successfully`;
          state.severity = "success";
        }
      })
      .addCase(lockUnlockQuota.rejected, (state, action) => {
        console.error("quota/lockUnlockQuota", action.error.message);
        state.isLoading = false;
      })

      .addCase(approveMultiple.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(approveMultiple.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === true) {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Approved Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Approve Failed`;
          state.severity = "error";
        }
      })
      .addCase(approveMultiple.rejected, (state, action) => {
        console.error("quota/approveMultiple", action.error.message);
        state.isLoading = false;
        state.messageOpen = true;
        state.message = `Selected ${TERMS.QUOTA_PLURAL} Approve Failed`;
        state.severity = "error";
      })

      .addCase(lockUnlockMultiple.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(lockUnlockMultiple.fulfilled, (state, action) => {
        state.isLoading = false;
        let rowcnt = action.payload.length;
        let lockcnt = action.payload.filter(
          (p) => p.isSubmitLocked == true
        ).length;
        let unlockcnt = action.payload.filter(
          (p) => p.isSubmitLocked == false
        ).length;
        if (typeof action.payload == "string") {
          state.messageOpen = true;
          state.message = action.payload;
          state.severity = "error";
        } else if (lockcnt == rowcnt) {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Locked Successfully`;
          state.severity = "success";
        } else if (unlockcnt == rowcnt) {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Unlocked Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message =
            "Lock changes for selected quotas updated successfully";
          state.severity = "success";
        }
      })
      .addCase(lockUnlockMultiple.rejected, (state, action) => {
        console.error("quota/lockUnlockMultiple", action.error.message);
        state.isLoading = false;
      })

      .addCase(rejectMultiple.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(rejectMultiple.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === true) {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Rejected Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Reject Failed`;
          state.severity = "error";
        }
      })
      .addCase(rejectMultiple.rejected, (state, action) => {
        console.error("quota/rejectMultiple", action.error.message);
        state.isLoading = false;
        state.messageOpen = true;
        state.message = `Selected ${TERMS.QUOTA_PLURAL} Reject Failed`;
        state.severity = "error";
      })

      .addCase(approveMultipleWithComment.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(approveMultipleWithComment.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload === true) {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Approved Successfully`;
          state.severity = "success";
        } else {
          state.messageOpen = true;
          state.message = `Selected ${TERMS.QUOTA_PLURAL} Approve Failed`;
          state.severity = "error";
        }
      })
      .addCase(approveMultipleWithComment.rejected, (state, action) => {
        console.error("quota/approveMultipleWithComment", action.error.message);
        state.isLoading = false;
        state.messageOpen = true;
        state.message = `Selected ${TERMS.QUOTA_PLURAL} Approve Failed`;
        state.severity = "error";
      })
      .addCase(DownloadFile.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(DownloadFile.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(DownloadFile.rejected, (state, action) => {
        console.error("quota/DownloadFile", action.error.message);
        state.isLoading = false;
      })
      .addCase(Upload.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(Upload.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.filepaths = payload;
        state.files = [];
      })
      .addCase(Upload.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export const { setState, reset } = quotaSlice.actions;
export default quotaSlice.reducer;
